import moment from 'moment';

export const saveCsv = (response: string, fileName: string): void => {
  const blob = new Blob([response], { type: 'text/csv' });
  const time = moment().format('HH-mm');

  const url = window.URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = url;
  link.download = `${fileName}--${time}.csv`;

  link.click();

  window.URL.revokeObjectURL(url);
};


export const saveSettlementCsv = (response: ArrayBuffer, fileName: string): void => {
  const blob = new Blob([response], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  });

  const time = moment().format('HH-mm');

  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${fileName}--${time}.xlsx`;

  link.click();
  window.URL.revokeObjectURL(url);
};
